import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SavedReport} from '../../../interfaces/saved-reports';
import {Serializer} from '../../../interfaces/serializer';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/store';
import {reportUpdateSettings} from '../../../store/report/report.actions';

@Component({
  selector: 'app-report-period-setting-dialog',
  templateUrl: './report-period-setting-dialog.component.html',
  styleUrls: ['./report-period-setting-dialog.component.scss']
})
export class ReportPeriodSettingDialogComponent {
  public readonly periodCtrl: FormControl = new FormControl();
  public readonly compareCtrl: FormControl = new FormControl(this.data.report.attributes.parameters.compare);

  public readonly form: FormGroup = new FormGroup<any>({
    period: this.periodCtrl,
    compare: this.compareCtrl
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: { report: Serializer<SavedReport>, disableComparison: boolean },
    private readonly _matDialogRef: MatDialogRef<ReportPeriodSettingDialogComponent>,
    private readonly _store: Store<AppState>
  ) {}

  public onSubmit(): void {
    this._store.dispatch(reportUpdateSettings({
      settings: {
        period: this.periodCtrl.value,
        compare: this.compareCtrl.value
      }
    }));

    this.onClose();
  }

  public onClose(): void {
    this._matDialogRef.close();
  }
}
